export default __webpack_public_path__ + "static/media/sanmar13.5e34ff3c.jpg";